import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { BehaviorSubject, Observable, map } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ImportserialService {

  constructor(private http: HttpClient) { }

  //Behavior Subject for Decimal Limit
  private decimal = new BehaviorSubject('');
  getDecimalValue(): Observable<any> {
    return this.decimal.asObservable();
  }

  setDecimalValue(decimal) {
    this.decimal.next(decimal);
  }

   //Behavior Subject for Qty Decimal Limit
   private qtyDecimal = new BehaviorSubject('');
   getQtyDecimalValue(): Observable<any> {
     return this.qtyDecimal.asObservable();
   }
 
   setQtyDecimalValue(lmt) {
     this.qtyDecimal.next(lmt);
   }

    //Behavior Subject for Base currency
    private orgCurrency = new BehaviorSubject(null);
    getOrgCurrency(): Observable<any> {
      return this.orgCurrency.asObservable();
    }
  
    setOrgCurrency(val) {
      this.orgCurrency.next(val);
    }

  getAllInventorySettings(): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}Product/InventorySettings`)
  }

  checkSerialNoInSystem(serialNo, warehouseId, productId, cmId): Observable<any> {
    let params = new HttpParams();
    params = cmId ? params.append('creditMemoId', cmId) : params;
    return this.http.get<any>(`${environment.inventorySalesUrl}Serial/CheckSerialAssociation?serial=${serialNo}&productIds=${productId}&warehouseId=${warehouseId}`, { params });
  }

  getColSettings(): Observable<any> {
    return this.http.get<any>(`${environment.configUrl}Configuration/SerialConfiguration`);
  }

  updateColSettings(data) {
    return this.http.put<any>(`${environment.configUrl}Configuration`, data);
  }

  getOrganizationTrackingDefaultSettings(serilTypeId): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}TrackingSetting?typeId=${serilTypeId}`);
  }

  uploadFilesByOrganization(data): Observable<any> {
    return this.http.post<any>(`${environment.documentStorageUrl}UploadAttachmentToOrganization`, data);
  }

  bulkImportSerials(warehouseId,attachmentId,data) {
    return this.http.post<any>(`${environment.inventoryURl}Product/BulkImportSerial?warehouseId=${warehouseId}&attachmentId=${attachmentId}&isMigrated=false`, data);
  }

  bulkImportActivations(month, year, batchId,attachmentId, data, type) {
    const urlMap = {
      residual: 'BulkImportResidualSerial',
      commission: 'BulkImportCommissionSerial',
      spiff: 'BulkImportSpiffSerial'
  };
  const url = urlMap[type] || 'BulkImportActivationSerial';
    return this.http.post<any>(`${environment.inventoryURl}Product/${url}?monthId=${month}&year=${year}&batchGroupId=${batchId}&attachmentId=${attachmentId}`, data);
  }

  getSerialDetailsData(pageNumber, pageSize, typeId, filters, searchValue, cols) {
    const obj = {
      globalSearchValue: searchValue,
      selectableColumns: cols,
      filter: null,
      pageNumber: pageNumber,
      pageSize: pageSize,
      sortByColumn: null,
      sortByColumnDataType: "",
      isSortByDescending: false,
      filterInColumns: filters,
      excludeDefaultColumns: false
    }
    return this.http.post<any>(`${environment.inventoryURl}SerialDetails/GetProductSerialDetailsWithFilter?typeId=${typeId}`, obj, { observe: 'response' }).pipe(
      map((res: HttpResponse<any>) => {
        return {
          serialDetails: res.body,
          headers: JSON.parse(res.headers.get('x-pagination'))
        };
      })
    );
  }

  getSerialDetailsDataByGroup(pageNumber, pageSize, typeId, filters, searchValue, cols, groupByColumn, subGroupByColumn, summaryCols) {
    const obj = {
      groupByColumnName: groupByColumn ?? '',
      subGroupByColumnName: subGroupByColumn ?? '',
      isGroupByColumnCSV: true,
      rootPageSize: pageSize,
      rootPageNumber: pageNumber,
      rootSortByColumnName: '',
      isRootSortByDescending: true,
      globalSearchValue: searchValue,
      selectableColumns: cols,
      filter: "",
      pageSize: pageSize,
      pageNumber: 1,
      sortByColumn: '',
      isSortByDescending: false,
      filterInColumns: filters,
      sumColumnName: summaryCols.map(fld => fld.columnName)
    }
    return this.http.post<any>(`${environment.inventoryURl}SerialDetails/GetProductSerialDetailsGroupped?typeId=${typeId}`, obj, { observe: 'response' }).pipe(
      map((res: HttpResponse<any>) => {
        return {
          serialDetails: res.body,
          headers: JSON.parse(res.headers.get('x-pagination'))
        };
      })
    );
  }

  getSubGroupSerialDetailsData(pageNumber, pageSize, typeId, filters, searchValue, cols, groupByCol, groupByVal, subGroupByCol, subGroupByVal,summaryCols) {
    const filterCopy = [...filters];
    if (!subGroupByCol) {
      filterCopy.push({
        name: groupByCol,
        operationType: 'AND',
        operator: 'IsEqualTo',
        value: null,
        values: [groupByVal]
      });
    } else {
      filterCopy.push({
        name: groupByCol,
        operationType: 'AND',
        operator: 'IsEqualTo',
        value: null,
        values: [groupByVal]
      },
        {
          name: subGroupByCol,
          operationType: 'AND',
          operator: 'IsEqualTo',
          value: null,
          values: [subGroupByVal]
        });
    }

    const obj = {
      globalSearchValue: searchValue,
      selectableColumns: cols,
      filter: null,
      pageNumber: pageNumber,
      pageSize: pageSize,
      sortByColumn: null,
      sortByColumnDataType: "",
      isSortByDescending: false,
      filterInColumns: filterCopy,
      excludeDefaultColumns: false,
      sumColumnName: summaryCols.map(fld => fld.columnName)
    }
    return this.http.post<any>(`${environment.inventoryURl}SerialDetails/GetProductSerialDetailsWithFilterForPagination?typeId=${typeId}`, obj);
  }

  getSerialOverviewData(trackingId, typeId): Observable<any> {
    let params = new HttpParams();
    params = params.append('trackingId', trackingId)
    params = params.append('typeId', typeId)
    return this.http.get<any>(`${environment.inventoryURl}SerialDetails/SerialTransactionDetails`, { params });
  }

  getAllLocations(includeInactive: boolean): Observable<any> {
    let params = new HttpParams();
    params = params.append('includeInactive', includeInactive)
    //return this.http.get<any>(`${environment.inventoryURl}Warehouse/WarehouseNames`, { params });

    return this.http.get<any>(`${environment.inventoryURl}Warehouse/WarehouseNames`).pipe(
      map(response => {
        // Transform the response here
        // For example, if the API returns an object with a 'data' property
        // and you want to extract and return just that property:
        return response.map(loc => {
          // Further transform each item if necessary
          return {
            customName: loc.name + ' - ' + loc.locationId,
            ...loc,
          };
        });
      })
    );
  }

  // Activation And Residual Tab start
  getActivationAndResidualsData(pageNumber, pageSize, typeId, filters, searchValue, cols, groupByColumn, serialId) {
    const obj = {
      globalSearchValue: searchValue,
      selectableColumns: cols,
      filter: null,
      pageNumber: pageNumber,
      pageSize: pageSize,
      sortByColumn: null,
      sortByColumnDataType: "",
      isSortByDescending: false,
      filterInColumns: filters,
      excludeDefaultColumns: false
    }
    return this.http.post<any>(`${environment.inventoryURl}SerialDetails/GetProductSerialDetailsWithFilterById?typeId=${typeId}&serialid=${serialId}`, obj, { observe: 'response' }).pipe(
      map((res: HttpResponse<any>) => {
        return {
          serialDetails: res.body,
          headers: JSON.parse(res.headers.get('x-pagination'))
        };
      })
    );
  }

  getActivationAndResidualsDataByGroup(pageNumber, pageSize, typeId, filters, searchValue, cols, groupByColumn, serialId) {
    const obj = {
      groupByColumnName: groupByColumn,
      isGroupByColumnCSV: true,
      rootPageSize: pageSize,
      rootPageNumber: pageNumber,
      rootSortByColumnName: '',
      subGroupByColumnName: '',
      isRootSortByDescending: true,
      globalSearchValue: searchValue,
      selectableColumns: cols,
      filter: "",
      pageSize: 15,
      pageNumber: 1,
      sortByColumn: '',
      isSortByDescending: false,
      filterInColumns: filters
    }
    return this.http.post<any>(`${environment.inventoryURl}SerialDetails/GetProductSerialDetailsGrouppedById?typeId=${typeId}&serialId=${serialId}`, obj, { observe: 'response' }).pipe(
      map((res: HttpResponse<any>) => {
        return {
          serialDetails: res.body,
          headers: JSON.parse(res.headers.get('x-pagination'))
        };
      })
    );
  }

  getActivationAndResidualsSubGroupData(pageNumber, pageSize, typeId, filters, searchValue, cols, groupByCol, groupByVal, serialId) {
    const filterCopy = [...filters];
    filterCopy.push({
      name: groupByCol,
      operationType: 'AND',
      operator: 'IsEqualTo',
      value: null,
      values: [groupByVal]
    });

    const obj = {
      globalSearchValue: searchValue,
      selectableColumns: cols,
      filter: null,
      pageNumber: pageNumber,
      pageSize: pageSize,
      sortByColumn: null,
      sortByColumnDataType: "",
      isSortByDescending: false,
      filterInColumns: filterCopy,
      excludeDefaultColumns: false
    }
    return this.http.post<any>(`${environment.inventoryURl}SerialDetails/GetProductSerialDetailsWithFilterForPaginationById?typeId=${typeId}&serialId=${serialId}`, obj);
  }
  // Activation And Residual Tab End

  getFilterData(typeId): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}TrackingSetting/TrackingField?typeId=${typeId}`);
  }

  getItemNoBySearch(searchValue): Observable<any> {
    const value = searchValue ?? '';
    return this.http.get<any>(`${environment.inventoryURl}Product/ProductNames?search=${value}`);
  }

  getAutoCompleteByFieldName(searchValue,filterItem): Observable<any> {
    const value = searchValue ?? '';
    const typeId = filterItem.selectedField?.typeId;
    const field = filterItem.selectedField?.columnName;
    return this.http.get<any>(`${environment.inventoryURl}SerialDetails/FilterSearchData?columnName=${field}&typeId=${typeId}&filter=${value}`);
  }

  getAutoCompleteRuleByFieldName(searchValue,filterItem): Observable<any> {
    const value = searchValue ?? '';
    const typeId = filterItem.selectedField?.typeId;
    const field = filterItem.selectedField?.code;
    return this.http.get<any>(`${environment.inventoryURl}SerialDetails/FilterSearchDataForProduct?columnName=${field}&typeId=${typeId}&filter=${value}`);
  }

  getAllGroups(parentGroupId?) {
    let params = new HttpParams();
    params = (parentGroupId ? params.append('parentGroupId', parentGroupId) : params)
    return this.http.get<any>(`${environment.inventoryURl}Group`, { params: params });
  }

  getAllGroupTypes(groupId) {
    return this.http.get<any>(`${environment.inventoryURl}Type?groupId=${groupId}`);
  }

  addBatchList(data) {
    return this.http.post<any>(`${environment.coreUrl}Type`, data)
  }

  updateBatchList(data) {
    return this.http.put<any>(`${environment.coreUrl}Type`, data)
  }

  // revert import data
  getImportDataList(pageNumber, pageSize, typeId) {
    let params = new HttpParams();
    params = (pageNumber ? params.append('PageNumber', pageNumber) : params)
    params = (pageSize ? params.append('PageSize', pageSize) : params)
    params = params.append('typeId', typeId)
    params = params.append('SortBy', 'CreatedDate')
    params = params.append('IsAscending', true)
    return this.http.get<any>(`${environment.inventoryURl}SerialDetails/ImportFileList`, { observe: 'response', params: params }).pipe(
      map((res: HttpResponse<any>) => {
        return {
          importList: res.body,
          headers: JSON.parse(res.headers.get('x-pagination'))
        };
      })
    );
  }

  rollBackImportFile(batchId,typeId) {
    let params = new HttpParams();
    params = params.append('typeId', typeId)
    params = params.append('fileBatchId', batchId)
    return this.http.get<any>(`${environment.inventoryURl}SerialDetails/RollBack`, { params: params });
  }

  getAllFinancialAccounts(): Observable<any> {
    return this.http.get<any>(`${environment.financeURl}FinancialAccount?accountType=0&showBalance=false`);
}
}
